import type CreditExposureNotificationStatus from "./creditExposureNotificationStatus";

export default class CurrentCreditExposure {
  total: number;
  reserved: number;
  remaining: number;
  warningNotificationStatus: CreditExposureNotificationStatus;
  warningPercentage: number;
  remainingPercentage: number;
}
